// Placeholder names as defined by TextTemplate.Tokens (backend). Each name doubles as the child
// key under settings.templates.placeholderPanel.items providing label/description/example
// (precedent: settings.parameters.names). The raw {{...}} token text is composed by
// toPlaceholderToken and must never live inside translation files — i18next would treat it as
// interpolation and swallow it.
export const TemplatePlaceholders = [
  { name: "KundennameInklusiveAnrede", isFixedValue: false },
  { name: "Kundenadresse", isFixedValue: false },
  { name: "BeraterinnenName", isFixedValue: false },
  { name: "BeraterDurchwahl", isFixedValue: false },
  { name: "AllgemeineDurchwahl", isFixedValue: true },
  { name: "Termin", isFixedValue: false },
  { name: "TerminAlt", isFixedValue: false },
  { name: "TerminNeu", isFixedValue: false },
  { name: "Link", isFixedValue: false },
  { name: "Terminlink", isFixedValue: false },
  { name: "1BFragebogenlink", isFixedValue: false },
  { name: "Registrierungslink", isFixedValue: false },
  { name: "PasswortResetLink", isFixedValue: false },
] as const;

export type TemplatePlaceholderName = (typeof TemplatePlaceholders)[number]["name"];

/** Raw token text inserted into template content, e.g. "{{Termin}}". Mirrors TextTemplate.Tokens (backend). */
export const toPlaceholderToken = (name: TemplatePlaceholderName): string => `{{${name}}}`;
